/**
 * Where the preview iframe for a base loads from.
 *
 *   legacy               — the game package's own prebuilt html, copied to the
 *                          static root by generateGamesManifest.js and keyed by
 *                          base id. A base without one has no preview at all.
 *   versionedPlayEngine  — the engine's dashboard-mode bundle that the
 *   snapshotEditor          agentContainer builds and the server mounts at
 *                          /snapshotPreview. One URL for every base: the bundle
 *                          carries no snapshot, the editor posts one into it.
 *   pe3d                 — none here: each variant previews its own release's
 *                          template, made in the browser (modules/pe3dRelease.js).
 *
 * Kept out of containerGamePreview so the decision has a test, and so the day
 * legacy bases move too is a one-line change here.
 */

import { getBaseKind, BASE_KINDS } from "./baseKind";
import { getSnapshotPreviewUri } from "./snapshotEditorApi";

/**
 * @param {object|null} base
 * @param {Record<string,string>} previewsGenerated  the manifest's base → html map
 * @returns {string|null}  the iframe src, or null when this base has no preview
 */
export function previewSourceFor(base, previewsGenerated) {
  const kind = getBaseKind(base);
  if (!kind || kind === BASE_KINDS.PE3D) return null;
  if (kind === BASE_KINDS.LEGACY) {
    const id = String(base._id);
    return Object.prototype.hasOwnProperty.call(previewsGenerated || {}, id)
      ? previewsGenerated[id]
      : null;
  }
  return getSnapshotPreviewUri();
}
